import { render, staticRenderFns } from "./homeList.vue?vue&type=template&id=4b664a0c&scoped=true&"
import script from "./homeList.vue?vue&type=script&lang=js&"
export * from "./homeList.vue?vue&type=script&lang=js&"
import style0 from "./homeList.vue?vue&type=style&index=0&id=4b664a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b664a0c",
  null
  
)

export default component.exports